<template>
  <div>
    <b-modal @close="onClose" v-model="isModalOpen" :title="title" centered hide-footer no-close-on-backdrop>
      <img :src="require('@/assets/images/banner/20250527_tendencias.jpeg')" width="100%" />
      <span v-if="link">
        <a :href="link" target="_blank" class="btn btn-primary mt-1 w-100">
          <i class="fas fa-video"></i> Acompanhe ao vivo
        </a>
        <p class="text-center">{{link}}</p>
      </span>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BButton, VBModal } from "bootstrap-vue";
export default {
  components: {
    BModal, BButton, VBModal
  },
  data() {
    return {
      isModalOpen: false,
      title: 'Ao vivo',
      key: '20250527_tendencias',
      link: 'https://us06web.zoom.us/j/85027601965'
    };
  },
  mounted() {
    const currentDate = new Date();
    const endDate = new Date('2025-05-27T23:59:59-03:00');

    const alreadyShow = localStorage.getItem('home-banner') === this.key;
    if (!alreadyShow && currentDate.getTime() < endDate.getTime()) {
      this.isModalOpen = true;
    }
  },
  methods: {
    onClose() {
      this.isModalOpen = false;
      localStorage.setItem('home-banner', this.key);
    }
  }
};
</script>

<style scoped>
</style>
